export const style = {
  selectPaperProps: (withElement, isOpenUpwards) => ({
    backgroundColor: "white",
    borderRadius: "20px",
    marginTop: isOpenUpwards ? "-16px" : "16px",
    padding: "8px",
    paddingTop: "62px",
    boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
    width: withElement ? withElement : "100%",

    "& .MuiMenu-list": {
      position: "static",
      listStyle: "none",
      height: "auto",
      maxHeight: { xs: "205px", md: "210px" },
      padding: 0,
      paddingRight: "8px",
      overflowY: "scroll",
    },
  }),
};
